import { SUBCLUSTERS } from '../subclusters.js';

const TECH_CLUSTER = {
    subclusters: [
        { key: SUBCLUSTERS.TASK_MANAGEMENT },
        { key: SUBCLUSTERS.SPRINT_MANAGEMENT },
        { key: SUBCLUSTERS.KANBAN },
        { key: SUBCLUSTERS.STORIES_EPICS_MANAGEMENT },
        { key: SUBCLUSTERS.ROADMAP_PLANNING },
        { key: SUBCLUSTERS.RELEASE_MANAGEMENT },
        { key: SUBCLUSTERS.TEAM_MANAGEMENT },
        { key: SUBCLUSTERS.TRACKING_PRODUCT_METRICS },
        { key: SUBCLUSTERS.CROSS_TEAM_COLLABORATION },
        { key: SUBCLUSTERS.REPORTS_DASHBOARDS },
        { key: SUBCLUSTERS.PRIORITIZE_PERSONAL_WORK },
        { key: SUBCLUSTERS.MARKET_RESEARCH },
        { key: SUBCLUSTERS.CUSTOMER_COMMUNICATION },
        { key: SUBCLUSTERS.FEATURE_PRIORITIZATION },
        { key: SUBCLUSTERS.BACKLOG_MANAGEMENT },
    ],
    mini_site: {
        logo: {
            src: 'https://dapulse-res.cloudinary.com/image/upload/DEV-oneliner-box.svg',
            url: '/dev',
            alt: 'monday.com Dev',
            mobileSrc: 'https://dapulse-res.cloudinary.com/image/upload/DEV-oneliner-box.svg',
        },
        links: [
            {
                url: '/dev',
                text: 'minisite.header.overview',
            },
            {
                url: '/dev/integrations',
                text: 'Integrations',
            },
            {
                url: '/dev/whats-new',
                text: 'minisite.header.whatsNew',
            },
            {
                url: '/dev/pricing',
                text: 'minisite.header.pricing',
                isPricingPage: 'true',
            },
        ],
        unifiedDesktopLogo: {
            url: '/dev',
            alt: 'monday.com Dev',
            src: 'https://dapulse-res.cloudinary.com/image/upload/DEV-oneliner-box.svg',
        },
    },
    payments_view: {
        pricing: {
            tier_descriptions: {
                pro: 'pricingPage.tierDescriptions.dev.pro',
                basic: 'pricingPage.tierDescriptions.dev.basic',
                standard: 'pricingPage.tierDescriptions.dev.standard',
                enterprise: 'pricingPage.tierDescriptions.dev.enterprise',
            },
            value_features: {
                pro: [
                    { feature: 'AGILE_REPORTING' },
                    { feature: 'PRO_DASHBOARDS' },
                    { feature: 'DEV_FEEDBACK_FORMS' },
                    { feature: 'PRIVATE_BOARDS' },
                    { feature: 'PRO_AUTOMATIONS' },
                    { feature: 'PRO_INTEGRATIONS' },
                ],
                basic: [
                    { feature: 'SPRINT_MANAGEMENT' },
                    { feature: 'KANBAN_MANAGEMENT' },
                    { feature: 'DEV_TEMPLATES' },
                    { feature: 'UNLIMITED_VIEWERS' },
                    { feature: 'UNLIMITED_ITEMS' },
                    { feature: 'UNLIMITED_BOARDS' },
                    { feature: 'BUILT_IN_WORKOCS' },
                ],
                standard: [
                    { feature: 'GIT_INTEGRATIONS' },
                    { feature: 'TIMELINE_AND_GANTT_VIEWS' },
                    { feature: 'SHARABLE_DEV_BOARDS' },
                    { feature: 'STANDARD_AUTOMATIONS' },
                    { feature: 'STANDARD_INTEGRATIONS' },
                ],
                enterprise: [
                    { feature: 'ENTERPRISE_SCALE_AUTOMATIONS' },
                    { feature: 'MULTI_LEVEL_PERMISSIONS' },
                    { feature: 'ENTERPRISE_GRADE_SECURITY' },
                    { feature: 'TAILORED_ONBOARDING' },
                    { feature: 'PREMIUM_SUPPORT' },
                    { feature: 'ENTERPRISE_DASHBOARDS' },
                ],
            },
        },
    },
};

export { TECH_CLUSTER };
